export class Finder {
    /**
     * @param {{fields:Array<{name: string, value: string|number|boolean|null}>}} data
     */
    constructor(data) {
        this.data = data;
    }
    /**
     * @returns {string|number|boolean|null}
     */
    find() {
        var currentNode = this.data;
        for (var i = 0; i < arguments.length; i++) {
            var name = arguments[i];
            currentNode = this.findByName(name, currentNode);
            if (!currentNode) {
                return null;
            }
        }
        return currentNode.value;
    }
    /**
     * @param {string} name
     * @param {{fields:Array<{name: string}>}} node
     * @returns {?Object}
     */
    findByName(name, node) {
        var fields = node.fields || [];
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.name === name) {
                return field;
            }
        }
        return null;
    }

}
